import React, { useContext, useEffect, useMemo } from 'react';
import { Choice } from '../../../atoms/Choice';
import { ChoiceGroup } from '../../../atoms/Choice/ChoiceGroup';
import { parseGivingFrequencyChoices } from '../donate-form-utils';
import { DonateFormContext } from '../DonateFormContext';

interface GivingFrequencyChoiceProps {
}

const givingFrequencyElements = document.querySelectorAll('#giving_frequency_container > span');
const GIVING_FREQUENCY_KEY = 'giving_frequency';

const GivingFrequencyChoice = ({  }: GivingFrequencyChoiceProps) => {
    const {formState, updateFormState} = useContext(DonateFormContext);
    const givingFrequencies = useMemo(() => parseGivingFrequencyChoices(givingFrequencyElements), []);

    useEffect(() => {
        const selectedGivingFrequency = givingFrequencies.find((gf) => gf.selected)?.value ?? '1';

        updateFormState(GIVING_FREQUENCY_KEY, selectedGivingFrequency);
    }, []);

    if (givingFrequencies.length === 0 || givingFrequencies.length === 1) {
        return null;
    }

    return (
        <ChoiceGroup>
            {givingFrequencies.map(({ name, value }, index) => {
                const isChecked = formState.giving_frequency === value;
                return (
                    <Choice
                        key={value}
                        tabIndex={isChecked ? 0 : -1}
                        label={name}
                        name="giving_frequency"
                        isChecked={isChecked}
                        onChange={(e) => updateFormState(e.target.name, e.target.value)}
                        value={value} />
                );
            })}
        </ChoiceGroup>
    );
}

export default GivingFrequencyChoice;
